<template>
    <div class="input">
        <input
            class="input__form"
            type="text"
            :value="value"
            @input="update"
            @blur="hook"
            @keyup.enter="hook"
            v-digitsonly
        >

        <div
            class="input__placeholder"
            v-if="placeholder && value.length < 1"
        >
            {{ placeholder }}
        </div>
    </div>
</template>

<script>
import {
    JustDigits,
} from '../../directives/filters.js'

JustDigits()

export default {
    name: 'Input',
    props: {
        value:  {
            type: [String, Number],
            default: '',
            required: true,
        },
        placeholder: {
            type: String,
            required: true,
        },
        update: {
            type: Function,
            required: true,
        },
        hook: {
            type: Function,
            required: true,
        },
    }
}
</script>

<style lang='scss' scoped>
@import '../../../sass/_variables.scss';
@import '../../../sass/_mixins.scss';

.input {
    font-family: 'Helvetica Neue', 'Segoe UI', 'Arial', sans-serif;
    border-bottom: 1px solid rgba(53, 53, 53, 1);
    position: relative;
    font-size: 22px;
    font-weight: 300;
    line-height: 1.5;
    
    @include bp('xs') {
        font-size: 30px;
        line-height: 1.5;
    }

    &__form {
        display: block;
        width: 100%;
        color: #fff;
        background: transparent;
        border: 0;
        font-family: inherit;
        font-size: inherit;
        font-weight: inherit;
        line-height: inherit;
    }

    &__placeholder {
        position: absolute;
        top: 0;
        left: 0;
        font-family: inherit;
        font-size: inherit;
        font-weight: inherit;
        line-height: inherit;
        color: rgba(68, 68, 68, 1);
        pointer-events: none;
        user-select: none;
    }
}
</style>